import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import leadsApt from "../../../../src/assets/blade-runner/session02/leahs-apt.webp";
import killMagazine from "../../../../src/assets/blade-runner/session02/kill_magazine.webp";
import holden from "../../../../src/assets/blade-runner/session02/dave_holden.webp";
import taffey from "../../../../src/assets/blade-runner/session02/taffey-token.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession02 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "The Snake Pit",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={taffey}
            caption="Taffey Lewis"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Taffey Lewis, proprietor of the infamous Snake Pit nightclub."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Marion leans into club owner Taffey, accusing him of paying people off
          and holding out on the investigation. Marion warns The Snake Pit will
          stay shuttered for another day until Taffey produces something
          worthwhile. Taffey, sweating but smirking, promises to{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “scrape the bottom of the barrel.”
          </font>
          <br />
          <br />
          Skinner, taking a softer tack, tells Taffey:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “You give us a little, we give you a little.”
          </font>
          <br />
          <br />
          Taffey shoots back with a mocking sneer, nodding toward Marion,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “What, you letting the kids do the work these days?”
          </font>
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Leah's Apartment",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={leadsApt}
            caption="Leah's Apartment"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Leah's Apartment is a cramped, dimly lit space filled with the remnants of a life lived messily. The air is thick with the scent of stale takeout and unwashed laundry."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Leah's apartment is in a Sector 5 apartment building, a rundown tower
          not far from LAPD HQ. The elevator is broken, forcing the detectives
          to climb thirteen flights of graffiti-covered, stinking stairs.
          Residents push past the blade runners with suspicious glares.
          <br />
          <br />
          At the top, Leah's door is marked with the words “skin job” in spray
          paint. A large man in a headband, reeking of cheap whisky, blocks the
          way. His friend “Bobby” slinks out of the shadows. The pair press the
          detectives: are they friends of the skin job—or maybe skin jobs
          themselves?
          <br />
          <br />
          Marion flashes his badge, jaw tight, his sensitivity about his own
          replicant status bubbling up. Skinner, calm and detached, hacks Leah's
          lock while deflecting:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Thanks, guys. Take it easy. This is a crime scene now. Bye bye.”
          </font>{" "}
          He shuts the door in their faces.
          <br />
          <br />
          Inside, the apartment tells a story:
          <ul>
            <li>
              An open book lay on the table, William Blake's "The Tyger" staring
              back. Marion picks up the book which narrates the poem as part of
              the augmented features. Marion stares at it, uncomprehending,
              unsettled.
            </li>
            <li>
              Skinner looks at a photo of a young girl sat on the nightstand.
              She is smiling, the background all a reddish haze. Where was this
              picture taken? He opens the frame once he discovers it's a
              physical photo. Doc Badger pawnshop logo is printed on the back of
              the picture. Skinner lingers over the photo, feeling a haunting
              resemblance to Leah in the little girl's face. His mood ring
              flickers.
            </li>
            <li>
              Marion examines a jar of glowing animoid butterflies. The beauty
              strikes him, but the connection to artificiality hits close. He
              takes empathy damage, shaken by the reminder that his own memories
              and sense of beauty are fabricated.
            </li>
          </ul>
          Before leaving the apartment, Skinner tells Marion: “Don't worry so
          much. You're trying too hard to be human.”
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Downtime",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={killMagazine}
            caption="KILL Magazine"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Jelle Shylar's hysterical anti-replicant rag. They make shit up, but people believe it."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner retreats to his usual haunt—a bar run by Lloyd, a Nexus-9
          doxie model. Their information-sharing arrangement is wordless,
          mutually beneficial. Lloyd keeps an eye on the street, and Skinner
          gives law enforcement perspective.
          <br />
          <br />
          Marion returns home to Wanda, his DiJi girlfriend. He tells her about
          Leah's apartment, about the strange artistic touches, the butterflies
          in the jar. He speaks of another Nexus-9 he knew who failed baseline
          test, who also had “weird stuff”. Wanda listens as Marion tries to
          make sense of it all, trying to draw lines between art, identity, and
          survival.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Day 2, Shift 1: Chewed Out",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={holden}
            caption="Holden"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Old Iron Lung is a legend from the old days, and
Holden has been the one-man army keeping the RDU
afloat for years. He’s also usually your Reporting Officer,
receiving regular updates on any open investigations,
though ROs may hail from other LAPD divisions or outside agencies depending on the case particulars."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Quell contacts Marion in early hours of the morning. He reports the
          blood sample from The Snake Pit and their visit to Leah's apartment.
          He carefully leaves out any evidence hinting at Leah's instability
          such as the poem, the butterflies, or the picture of the little girl.
          <br />
          <br />
          Skinner, meanwhile, gets a call from Deputy Chief Holden, furious
          about Jelle Schyler's smear in KILL magazine: a headline claiming a
          malfunctioning Nexus-9 had caused the Snake Pit shooting. Skinner
          tried to reason with him:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "You know how that rag is; they make shit up. You'll go to an early
            grave worrying about this stuff."
          </font>{" "}
          Holden wasn't buying it. Both detectives had to burn a shift at HQ,
          talking Holden down to avoid losing promotion points.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Shots Fired (Day 2, Shift 2)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          Marion sets out for Little Tokyo to meet with his contact Corgi.
          <br />
          Skinner travels to visit Doc Badger's pawnshop.
          <br />
          <br />
          Before either runner can make progress, both detectives come under
          sniper fire at their respective destinations. The session ended on
          that cliffhanger, bullets cutting through the neon-soaked rain.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">THE TYGER</h1>
              <small>Blade Runner Session 02</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Holden chews out the gumshoes, Leah's apartment yields clues,
                  and our detectives take some downtime to rest before Day 2 of
                  the investigation.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Electric Dreams case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 01:{" "}
                  <a href="./blade-runner-session-01">Waking Up</a> -- Session
                  03: <a href="./blade-runner-session-03">Memory Lab</a> ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession02;
